export const GET_COMPANY_REPORT = gql`
    query companyReportLookup($companyNumber: String!, $companyBusinessIndicator: String) {
        companyReportLookUp(
            companyNumber: $companyNumber
            companyBusinessIndicator: $companyBusinessIndicator
        ) {
            websiteURL
            companyName
            registrationNumber
            pi_BusinessType
            companyIncorporationDate
            companyAddress
            eircode
            directors {
                firstName
                lastName
                dateOfBirth
                middleNames
                personalAddress {
                    addressLine1
                    addressLine2
                    country
                }
                position
                nationality
                title
                numberOfShares
                shareholderPercentage
            }
            shareholderReport {
                b1DocumentId
                totalShares
                shareSummary
                shareholders {
                    classType
                    currency
                    director
                    numberOfShares
                    shareholderName
                    shareholderAddress1
                    shareholderAddress2
                    shareholderAddress3
                    shareholderAddress4
                    shareholderSurname
                    shareholderCompanyName
                }
            }
            submittedDocuments {
                doc_id
                doc_type_code
                doc_type_desc
            }
        }
    }
`;
